/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateExamTypeForChannelDto
 */
export interface CreateUpdateExamTypeForChannelDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamTypeForChannelDto
     */
    examTypeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamTypeForChannelDto
     */
    appointmentChannelId?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateExamTypeForChannelDto interface.
 */
export function instanceOfCreateUpdateExamTypeForChannelDto(value: object): value is CreateUpdateExamTypeForChannelDto {
    return true;
}

export function CreateUpdateExamTypeForChannelDtoFromJSON(json: any): CreateUpdateExamTypeForChannelDto {
    return CreateUpdateExamTypeForChannelDtoFromJSONTyped(json, false);
}

export function CreateUpdateExamTypeForChannelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateExamTypeForChannelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'examTypeId': json['examTypeId'] == null ? undefined : json['examTypeId'],
        'appointmentChannelId': json['appointmentChannelId'] == null ? undefined : json['appointmentChannelId'],
    };
}

export function CreateUpdateExamTypeForChannelDtoToJSON(value?: CreateUpdateExamTypeForChannelDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'examTypeId': value['examTypeId'],
        'appointmentChannelId': value['appointmentChannelId'],
    };
}

